import React, { useState } from "react";

import Notification from "../Notification/Notification";

import { searchUsers, sendFriendRequestById } from "../../services/friendService";

import "./SearchFriends.css";

const SearchFriend =({token}) =>{
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [noResults, setNoResults] = useState(false);
    const [notif, setNotif] = useState("");

  const handleSearch = async () => {
    if (!query) {
      setResults([]);
      setNoResults(false);
      return;
    }

    try {
      const res = await searchUsers(query);
      if (res.data.length === 0) {
        setResults([]);
        setNoResults(true);
      } else {
        setResults(res.data);
        setNoResults(false);
      }
    } catch (err) {
      console.error(err);
      setResults([]);
      setNoResults(true);
    }
  };

  const sendFriendRequest = async (id) => {
  try {
    const res = await sendFriendRequestById(id);

    setNotif(res.data.msg);
  } catch (err) {
    if (err.response) {
      setNotif(err.response.data.msg);
    } else {
      setNotif("Error sending request");
    }
    console.error(err);
  }
};

  return (
    <>
    <Notification message={notif} onClose={() => setNotif("")} />

    <div className="search-friend-container">
      <div className="search-input-wrapper">
        <input
          type="text"
          placeholder="Search by username or ID"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      <ul className="search-results">
        {results.length > 0
          ? results.map(user => (
              <li key={user._id} className="search-result-item">
                <div className="user-info">
                  <span className="username">{user.username}</span>
                  <span className="user-id">{user.id}</span>
                </div>
                <button className="add-friend-btn"
                onClick={() => sendFriendRequest(user._id)}
                >Add</button>
              </li>
            ))
          : noResults && <li className="no-results">No results found</li>}
      </ul>
    </div>
    </>
  );
}

export default SearchFriend;
